<div class="requirements">
  <h4>{{ 'changePassword.requirementsHeader' | translate }}</h4>
  <ul>
    <li [class.valid]="validations.minLength">{{ 'changePassword.requirement1' | translate }}</li>
    <li [class.valid]="validations.uppercase">{{ 'changePassword.requirement2' | translate }}</li>
    <li [class.valid]="validations.number">{{ 'changePassword.requirement3' | translate }}</li>
    <li [class.valid]="validations.specialChar">{{ 'changePassword.requirement4' | translate }}</li>
  </ul>
</div>
